(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("NetlifyCmsApp", ["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["NetlifyCmsApp"] = factory(require("react"), require("react-dom"));
	else
		root["NetlifyCmsApp"] = factory(root["React"], root["ReactDOM"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__61__) {
return 